import { render, staticRenderFns } from "./WhatsappLog.vue?vue&type=template&id=0db6a66d&"
import script from "./WhatsappLog.vue?vue&type=script&lang=js&"
export * from "./WhatsappLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports